import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    button: {
        margin: 0,
        fontSize: '10px',
        padding: theme.spacing(),
    },
});

const DetailsButton = ({ classes, onClick, ...buttonProps }) => {
    return (
        <Button
            size="small"
            variant="outlined"
            className={classes.button}
            onClick={onClick}
            {...buttonProps}
        >
            Details
        </Button>
    );
};

export default withStyles(styles)(DetailsButton);
